import {
  CommissionConsentContent,
  EndorsementsConsent,
  EndUserLicenseAgreementContent,
  KnownSignerConsent,
  PrivacyPolicyConsent,
  TermsAndConditionsConsent,
  UseOfAIConsent,
} from '../../models';

export interface State {
  privacy: PrivacyPolicyConsent;
  termsAndConditions: TermsAndConditionsConsent;
  useOfAI: UseOfAIConsent;
  knownSigner: KnownSignerConsent;
  endorsements: EndorsementsConsent;
  eula: EndUserLicenseAgreementContent;
  commission: CommissionConsentContent;
  isPrivacyPolicyConsentCheckBoxEnabled: boolean;
  isTermsOfUseConsentCheckBoxEnabled: boolean;
  isSignatureConsentAgreementCheckboxEnabled: boolean;
  isUseOfAIConsentCheckBoxEnabled: boolean;
}

export const initialState: State = {
  privacy: null,
  termsAndConditions: null,
  useOfAI: null,
  endorsements: null,
  eula: null,
  commission: null,
  knownSigner: null,
  isPrivacyPolicyConsentCheckBoxEnabled: false,
  isTermsOfUseConsentCheckBoxEnabled: false,
  isSignatureConsentAgreementCheckboxEnabled: false,
  isUseOfAIConsentCheckBoxEnabled: false
};
